/**
 * Created by ganlu on 20/10/2016.
 */
export default {
    server_url: 'https://api.yuanben.io',
    aliyun_url:'https://yb-img.oss-cn-shanghai.aliyuncs.com',
    chain_server_url: 'https://dna.yuanbenlian.com',
    newchain_server_url: 'https://yuanbenlian.com',
    weixin_link_suffix: '&devicetype=Windows-QQBrowser&version=61030004&pass_ticket=qMx7ntinAtmqhVn+C23mCuwc9ZRyUp20kIusGgbFLi0=&uin=MTc1MDA1NjU1&ascene=1',
    report_threshold_value: 4000,
    plugin_id: '6148d3bb-1178-457e-bc4b-bbaf789222db'
};



// WEBPACK FOOTER //
// ./src/app/config.js